// extracted by mini-css-extract-plugin
module.exports = {"formCommentList":"_-ui-careers-lib-FormCommentList-index-module__formCommentList--3coCI"};